module.exports = __webpack_public_path__ + "img/ad_4.c65aa4f2.png";